"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetCorrespondingAngularRoute = exports.useCorrespondingAngularRoute = exports.CHANGE_CORRESPONDING_ROUTE_EVENT = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var CHANGE_CORRESPONDING_ROUTE_EVENT = 'CHANGE_CORRESPONDING_ROUTE_EVENT';
exports.CHANGE_CORRESPONDING_ROUTE_EVENT = CHANGE_CORRESPONDING_ROUTE_EVENT;
var useCorrespondingAngularRoute = function useCorrespondingAngularRoute() {
  var _useState = (0, _react.useState)('/'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    correspondingRoute = _useState2[0],
    setCorrespondingRoute = _useState2[1];
  (0, _react.useEffect)(function () {
    var listener = function listener(e) {
      setCorrespondingRoute(e.detail);
    };
    document.addEventListener(CHANGE_CORRESPONDING_ROUTE_EVENT, listener, false);
    return function () {
      return document.removeEventListener(CHANGE_CORRESPONDING_ROUTE_EVENT, listener);
    };
  }, [setCorrespondingRoute]);
  return correspondingRoute;
};
exports.useCorrespondingAngularRoute = useCorrespondingAngularRoute;
var useSetCorrespondingAngularRoute = function useSetCorrespondingAngularRoute(route) {
  (0, _react.useEffect)(function () {
    var event = new CustomEvent(CHANGE_CORRESPONDING_ROUTE_EVENT, {
      detail: route
    });
    document.dispatchEvent(event);
  }, [route]);
};
exports.useSetCorrespondingAngularRoute = useSetCorrespondingAngularRoute;